class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  /*
    CRT-02 - Announce the change. WCAG 2.2 SC 4.1.3 Status Messages.
    The live region deliberately lives in layout/theme.liquid, outside #mini-cart:
    the loop below replaces that element's contents on every cart update, and a
    live region that is destroyed and recreated is not announced.
  */
  announce(message) {
    const region = document.getElementById('a11y-cart-status');
    if (!region || !message) return;
    // Clear first so an identical repeat message still registers as a change.
    region.textContent = '';
    requestAnimationFrame(() => {
      region.textContent = message;
    });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];

      if (element && sectionHTML) {
        element.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      }
    }));

    // CRT-02: adding three announced the same sentence as adding one, so the visitor
    // had no way to tell the quantity had taken.
    const title = parsedState.product_title || parsedState.title;
    const quantity = parseInt(parsedState.quantity, 10);
    const strings = window.cartStrings || {};
    if (title) {
      if (quantity > 1 && strings.itemsAdded) {
        this.announce(strings.itemsAdded.replace('[product]', title).replace('[quantity]', quantity));
      } else if (strings.itemAdded) {
        this.announce(strings.itemAdded.replace('[product]', title));
      }
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    
    if (!element) {
      return parsedHTML.body.innerHTML;
    }
    
    return element.innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
